import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateObraEstruturaOrganizacionalColumns
 */

type Props = {
  onActionEditar: (idEstruturaOrganizacional: number | null, openState: boolean) => void,
  onActionDeletar: (idEstruturaOrganizacional: number | null, openState: boolean) => void,
};

export const GenerateObraEstruturaOrganizacionalColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "nome",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "cargo",
      filterable: false,
      headerName: "Cargo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: 'idEstruturaOrganizacional',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}